import WorkSpacesList from "./WorkSpacesList";
import React from "react";
import { Navigate, Outlet, useLocation, useMatch } from "react-router";
import { SocketProvider } from "../context/SocketContext";
import { useAuth } from "../context/AuthContext";
import ThemeToggle from "./ThemeToggle";
import AccountMenu from "./AccountMenu";
import PolicyLinks from "./PolicyLinks";
import AppBottomNavigation from "./AppBottomNavigation";

const SocketLayout = () => {
  const match = useMatch("/courses/:slug/*");
  const slug = match?.params.slug;
  const { userId, authLoading, sessionVerified } = useAuth();
  const { pathname } = useLocation();
  const privatePage = /^\/(settings|courses|choose-plan|subscription-verification|subscription-successful|owner-payouts|group-memberships|payouts)(\/|$)/.test(pathname);
  const authPage = pathname === "/login" || pathname === "/signup";
  const recoveryPage = pathname === "/forgot-password" || pathname === "/reset-password";
  const minimalPage = authPage || recoveryPage;
  const guestOnlyPage = authPage || pathname === "/";
  const standalone = authPage || /^\/(join|choose-plan|subscription-verification|subscription-successful)(\/|$)/.test(pathname);
  if (guestOnlyPage && authLoading) return <div className="min-h-screen bg-white" aria-label="Checking session" />;
  if (guestOnlyPage && sessionVerified && userId) return <Navigate to="/explore" replace />;
  if (privatePage && !userId && !authLoading) return <Navigate to="/login" replace />;
  return (
    <SocketProvider slug={slug}>
      <div className={!slug && !minimalPage ? "app-bottom-layout" : undefined}>
      {!minimalPage && pathname !== "/choose-plan" && !pathname.startsWith("/join/") && standalone && <div className="flex justify-end border-b border-gray-100 bg-white px-4 py-2">{userId ? <AccountMenu /> : <ThemeToggle />}</div>}
      <Outlet />
      {userId && <WorkSpacesList key={userId} embedded popupOnly />}
      {pathname === "/" && <footer className="border-t border-gray-100 bg-white"><PolicyLinks /></footer>}
      {!slug && !minimalPage && <AppBottomNavigation />}
      </div>
    </SocketProvider>
  );
};

export default SocketLayout;
